<template>
  <div class="grid-row grid-row_sm d-flex_wrap d-flex_lg-nowrap">
    <div
      class="grid-col pt-8"
      v-for="(item, index) of getBadgesList"
      :key="index"
    >
      <div
        v-if="!item?.icon?.length"
        class="label border-radius-rounded fs-14"
        :class="classLabel[1]"
      >
        {{ item.value }}
      </div>
      <div
        v-if="item?.icon?.length > 0"
        class="label border-radius-rounded fs-14"
        :class="classLabel[1]"
      >
        <Icon iconName="icon-badge-person" className="icon-16 mr-4" />
        <span class="d-block">{{ item.value }}</span>
      </div>
    </div>

    <div class="grid-col pt-8" v-for="(item, index) of getActions" :key="index">
      <a
        :href="getPopupLink(item)"
        v-if="!item?.icon?.length && item.code"
        class="label border-radius-rounded fs-14 js-popup-link"
        :class="classLabel[0]"
      >
        {{ item.name }}
      </a>
      <div
        v-if="!item?.icon?.length && !item.code"
        class="label border-radius-rounded fs-14 js-popup-link"
        :class="classLabel[0]"
      >
        {{ item.name }}
      </div>
      <div
        v-if="item?.icon?.length > 0"
        class="label border-radius-rounded fs-14"
        :class="classLabel[0]"
      >
        <Icon iconName="icon-badge-person" className="icon-16 mr-4" />
        <span class="d-block">{{ item.name }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import { useProductStore } from "@/pages/product_card/stores/store_catalog";
import { mapState } from "pinia";
import Icon from "@/pages/product_card/components/Icon/Icon.vue";

export default {
  name: "BadgeDetail",
  components: { Icon },
  data() {
    return {
      classLabel: ["label_primary", "label_tertiary"],
    };
  },
  props: {
    items: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  methods: {
    getPopupLink(item) {
      return (
        "/local/templates/orteka_desktop/components/bitrix/catalog.item/.default/card/ajax.php?ELEMENT_ID=" +
        item.id
      );
    },
  },
  computed: {
    ...mapState(useProductStore, ["getBadgesList", "getActions"]),
  },
};
</script>
